export interface ProjectProgressEventDetail {
  projectId: string;
  reason?: string;
  timestamp: number;
}

const EVENT_NAME = 'project-progress:update';

const isBrowser = () => typeof window !== 'undefined';

export const emitProjectProgressUpdate = (projectId?: string, reason?: string) => {
  if (!projectId || !isBrowser()) {
    return;
  }

  const detail: ProjectProgressEventDetail = {
    projectId,
    reason,
    timestamp: Date.now()
  };

  window.dispatchEvent(new CustomEvent<ProjectProgressEventDetail>(EVENT_NAME, { detail }));
};

export const subscribeToProjectProgressUpdates = (
  handler: (detail: ProjectProgressEventDetail) => void
) => {
  if (!isBrowser()) {
    return () => {};
  }

  const listener = (event: Event) => {
    const customEvent = event as CustomEvent<ProjectProgressEventDetail>;
    if (customEvent.detail) {
      handler(customEvent.detail);
    }
  };

  window.addEventListener(EVENT_NAME, listener as EventListener);

  return () => window.removeEventListener(EVENT_NAME, listener as EventListener);
};

